/**
 * Composable useReferralBonusList — отсортированный список тарифов с бонусными днями за реферала.
 *
 * Используется в местах, где показывается разбивка «какой тариф — сколько бонусных дней»
 * (тултип у иконки info в PromoInterface и ProfilePage).
 *
 * Логика:
 * - Фильтруем тарифы с referralBonusDays > 0 (тарифы без бонуса не показываем)
 * - Сортируем по periodDays — от короткого тарифа к длинному
 * - Если тарифы ещё не загружены, подгружаем их через apiStore.getTariffs()
 */

import { computed, onMounted } from 'vue'
// Стор с публичными тарифами — источник данных для списка
import { useApiStore } from '@/modules/api/store/apiStore'

/**
 * Возвращает computed со списком тарифов, у которых referralBonusDays > 0.
 * Список отсортирован по длительности периода (ascending).
 *
 * @returns объект с полем referralBonusList (Vue computed ref)
 */
export function useReferralBonusList() {
  const apiStore = useApiStore()

  // Тарифы с ненулевым бонусом, отсортированные по длительности периода
  const referralBonusList = computed(() =>
    apiStore.tariffs
      .filter((t) => (t.referralBonusDays || 0) > 0)
      .slice()
      .sort((a, b) => a.periodDays - b.periodDays),
  )

  // Гарантируем что тарифы загружены — потребитель может находиться на странице без TariffsInterface
  onMounted(async () => {
    if (!apiStore.tariffs.length) await apiStore.getTariffs()
  })

  return { referralBonusList }
}
